import { useTranslation } from 'react-i18next'; // Import the translation hook for multi-language support
import { useDispatch } from 'react-redux'; // Import the useDispatch hook to dispatch actions to Redux store
import { useState } from 'react';
import {
    AddVehicleWithContractId
} from '../../../../reduxToolkit/Contractor/ContractorApi';
import { toast } from 'react-toastify';
import { errorMsg } from '../../../../Apis/functions'; // Import React hooks

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const AddVehiclesModalApp = ({ onHide, selectedId, setModified, show }) => {
    const { t } = useTranslation(); // Initialize the translation function
    const dispatch = useDispatch(); // Get the dispatch function to dispatch actions to Redux
    const [selectedVehicle, setSelectedVehicle] = useState([]);
    // Function to handle adding a user to the selection list
    const handleAdd = (items) => {
        const all_items = items?.map((item) => item?.id); // Get the IDs of all selected items
        if (all_items) {
            let data = {
                vehicleIds: all_items,
                contractId: selectedId,
            };
            dispatch(AddVehicleWithContractId(data)).then(
                ({
                    payload: {
                        data: { success, code },
                    },
                }) => {
                    if (success === true) {
                        toast.success(t('has_been_added_successfully')); // Show success message
                        setModified(true);
                        onHide();
                    } else errorMsg(code);
                },
            );
        }
    };

    // Return the necessary variables and functions for use in other parts of the app
    return {
        t, // Translation
        handleAdd,
        selectedVehicle,
        setSelectedVehicle,
        id: selectedId,
    };
};

export default AddVehiclesModalApp; // Export the component to be used in other parts of the app
